if (!customElements.get('marquee-slider')) {
  customElements.define(
    'marquee-slider',
    class MarqueeSlider extends HTMLElement {
      constructor() {
        super();

        this.marqueeLists = this.querySelectorAll('[data-marquee-list]');

        this.lastX = undefined;
        this.lastTransformX = 0;
        this.currTransformX = 0;
        
        this.addEventListener('touchstart', (e) => {
          if (this.resetPlayState) clearTimeout(this.resetPlayState);
          this.lastX = e.touches[0].screenX;
          this.marqueeLists.forEach(mrql => mrql.style.setProperty('animation-play-state', 'paused'));
        });

        this.addEventListener('touchmove', (e) => {
          if (e.target.closest('product-card-media-slider')) return;
          let lastX = this.lastX;
          let currX = e.touches[0].screenX;
          this.currTransformX = (this.lastTransformX + (100*(currX - lastX))/this.marqueeLists[0].clientWidth) % 100;
          this.marqueeLists.forEach(mrql => mrql.style.setProperty('transform', `translateX(${this.currTransformX}%)`));
        });

        this.addEventListener('touchend', (e) => {
          this.resetPlayState = window.setTimeout(() => {
            this.marqueeLists.forEach(mrql => mrql.style.setProperty('animation-play-state', ''));
          }, 0);         
          this.lastTransformX = this.currTransformX;
        });

      }
    }
  )
}